import AnalysisSettings from './component'

export default AnalysisSettings
